import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingOrderRequestDataImplEncoder } from "../../encoder/FixingOrderRequestDataImplEncoder";

import * as CubiqTS from "../../index";
import { FixingOrderRequestData } from "../FixingOrderRequestData";

export class FixingOrderRequestDataImpl
  extends ConcreteEncodable
  implements FixingOrderRequestData
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.FixingOrderRequestDataImpl";

  /*FID=1*/
  public accountCode: string;
  /*FID=3*/
  public base: string;
  /*FID=4*/
  public clientCode: string;
  /*FID=5*/
  public comment: string;
  /*FID=6*/
  public comment2: string;
  /*FID=8*/
  public externalClientReference: string;
  /*FID=12*/
  public fixedCcy: string;
  /*FID=16*/
  public markup: string;
  /*FID=17*/
  public nonBase: string;
  /*FID=18*/
  public orderId: string;
  /*FID=19*/
  public orderType: CubiqTS.OrderType;
  /*FID=20*/
  public product: CubiqTS.Product;
  /*FID=21*/
  public requestOrderType: CubiqTS.RequestOrderType;
  /*FID=24*/
  public stpHold: boolean;
  /*FID=25*/
  public strategyParameters: Array<CubiqTS.StrategyParameter> | null = null;
  /*FID=27*/
  public traderGroup: string;
  /*FID=28*/
  public tradingChannel: string;
  /*FID=32*/
  public isPrivateOrder: boolean;
  /*FID=36*/
  public useDefaultClientDataFg: boolean;
  /*FID=37*/
  public clientContactIds: Array<CubiqTS.Long> | null = null;
  /*FID=40*/
  public customValues: Array<CubiqTS.CustomValue> | null = null;
  /*FID=41*/
  public markupType: CubiqTS.MarkUpType;
  /*FID=45*/
  public passthroughParameters: Array<CubiqTS.StrategyParameter> | null = null;
  /*FID=48*/
  public oboClient: string;
  /*FID=49*/
  public oboAccount: string;
  /*FID=50*/
  public orderRef: string;
  /*FID=51*/
  public autoForwardPricing: boolean;
  /*FID=60*/
  public fixedAmount: string;
  /*FID=61*/
  public fixingDate: CubiqTS.StandardDate | null = null;
  /*FID=62*/
  public fixingSource: string;
  /*FID=63*/
  public tenor: CubiqTS.Tenor;
  /*FID=64*/
  public valueDate: CubiqTS.StandardDate | null = null;
  /*FID=65*/
  public clientIntent: CubiqTS.OrderIntent;
  /*FID=66*/
  public swapFixedAmount: string;
  /*FID=67*/
  public fixingTime: CubiqTS.StandardTime | null = null;
  /*FID=68*/
  public swapTenor: CubiqTS.Tenor;
  /*FID=69*/
  public swapValueDate: CubiqTS.StandardDate | null = null;
  /*FID=70*/
  public allocations: Array<CubiqTS.AllocationRequestData> | null = null;
  /*FID=71*/
  public farAllocations: Array<CubiqTS.AllocationRequestData> | null = null;
  /*FID=72*/
  public fwdNettingId: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingOrderRequestDataImplEncoder.Instance;
    this.setEncodableType(FixingOrderRequestDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingOrderRequestDataImpl[" +
      "accountCode=" +
      this.accountCode +
      "base=" +
      this.base +
      "clientCode=" +
      this.clientCode +
      "comment=" +
      this.comment +
      "comment2=" +
      this.comment2 +
      "externalClientReference=" +
      this.externalClientReference +
      "fixedCcy=" +
      this.fixedCcy +
      "markup=" +
      this.markup +
      "nonBase=" +
      this.nonBase +
      "orderId=" +
      this.orderId +
      "orderType=" +
      this.orderType +
      "product=" +
      this.product +
      "requestOrderType=" +
      this.requestOrderType +
      "stpHold=" +
      this.stpHold +
      "autoForwardPricing=" +
      this.autoForwardPricing +
      "strategyParameters=" +
      this.strategyParameters +
      "traderGroup=" +
      this.traderGroup +
      "tradingChannel=" +
      this.tradingChannel +
      "isPrivateOrder=" +
      this.isPrivateOrder +
      "useDefaultClientDataFg=" +
      this.useDefaultClientDataFg +
      "clientContactIds=" +
      this.clientContactIds +
      "customValues=" +
      this.customValues +
      "markupType=" +
      this.markupType +
      "passthroughParameters=" +
      this.passthroughParameters +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "fixedAmount=" +
      this.fixedAmount +
      "fixingDate=" +
      this.fixingDate +
      "fixingSource=" +
      this.fixingSource +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "clientIntent=" +
      this.clientIntent +
      "swapFixedAmount=" +
      this.swapFixedAmount +
      "fixingTime=" +
      this.fixingTime +
      "swapTenor=" +
      this.swapTenor +
      "swapValueDate=" +
      this.swapValueDate +
      "allocations=" +
      this.allocations +
      "farAllocations=" +
      this.farAllocations +
      "fwdNettingId=" +
      this.fwdNettingId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
